"use client";
import { Heading, HeadingProps } from "@chakra-ui/react";
import LoadWithChild, { LoadWithChildProps } from "./load-with-child";

export type LoadingProps = LoadWithChildProps & {
  message?: string[];
  textSx?: HeadingProps;
};
export default function LoadingWrapper({
  message = ["Loading"],
  textSx,
  ...props
}: LoadingProps) {
  const defaultOptions: Partial<HeadingProps> = {
    color: "blue.500",
    textAlign: "center",
    children: message[0],
  };
  return (
    <LoadWithChild {...props}>
      <Heading
        mx="auto"
        px="6"
        pt="4"
        as={"h3"}
        fontSize="2xl"
        {...defaultOptions}
        {...textSx}
      />
    </LoadWithChild>
  );
}
